module.exports = __webpack_public_path__ + "img/catB.d63afbb5.svg";